import { Control } from '../../../types/types';
import { shouldSendFormValue } from '../../../utils/shouldSendFormValue';
import { getDefaultValueByType } from '../../../utils/getDefaultValueByType';

const STATIC_CONTROL_TYPES = [
  'staticText',
  'staticString',
  'staticNumber',
  'literalText',
];

export const createRequestBody = (
  form: Record<string, any>,
  formValues: Record<string, unknown>,
  defaultValues?: Record<string, unknown>,
  // Submit method — enables the saved.onPOST/onPUT rules; without it only
  // saved.omitIfEmpty applies.
  method?: 'POST' | 'PUT'
) => {
  const body: Record<string, unknown> = {};
  // Create all items from the form definition
  form?.items
    ?.filter(
      // Do not send static input values to server
      (item) =>
        (!item.control || !STATIC_CONTROL_TYPES.includes(item.control.type)) &&
        // The definition `saved` rules (omitIfEmpty, onPOST/onPUT)
        shouldSendFormValue(item.saved, formValues[item.name], method)
    )
    .forEach((item) => {
      body[item.name] = getDefaultValueByType(item.type);
    });

  // Rewrite with provided default values
  if (defaultValues) {
    Object.keys(defaultValues).forEach((key) => {
      //Get-returned keys without an item definition must still be sent
      const hasItemDefinition: boolean =
        form?.items?.some((item: { name?: string }) => item.name === key) ??
        false;
      if (
        Object.prototype.hasOwnProperty.call(body, key) ||
        !hasItemDefinition
      ) {
        body[key] = defaultValues[key];
      }
    });
  }

  // Assign values from form
  Object.keys(formValues).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(body, key)) {
      const formItem = form.items.find(({ name }) => name === key);
      // Empty fields that are not string inputs should send null
      if (
        (formItem?.type !== 'string' ||
          (formItem?.control as Control)?.type !== 'string') &&
        formValues[key] === ''
      ) {
        body[key] = null;
      } else {
        const isStringControl =
          (formItem?.control as Control)?.type === 'string';
        body[key] =
          isStringControl && typeof formValues[key] === 'string'
            ? (formValues[key] as string).trimEnd()
            : formValues[key];
      }
    }
  });

  return body;
};
